<template>
  <div>
    <el-select v-if="companies.length > 1" v-model="_id" class="mr-3" placeholder="選擇經銷商" @clear="_id = null" @change="onSelect">
      <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
    <div v-else>
      <h3 class="my-0">{{ companies[0].name }}</h3>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('variable', ['companies']),
    _id: {
      get() {
        return this.id;
      },
      set(val) {
        this.$emit('update:id', val);
      },
    },
  },
  props: {
    id: {
      default: 0,
    },
    filter_all: {
      default: false,
    },
  },
  data() {
    return {};
  },

  async mounted() {
    // if (this.filter_all && this.companies[0].id === -10000) {
    //   this.companies.shift();
    // } else if (!this.filter_all && this.companies[0].id !== -10000) {
    //   this.companies.splice(0, 0, {
    //     id: -10000,
    //     name: '所有經銷',
    //   });
    // }
    this._id = this.companies[0].id;
    this.$emit('onSelect');
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
  },
};
</script>
